import { Box, Typography } from "@mui/material";
import { InvoiceItemDto } from "../../models/dto/CreateInvoiceDto";

type Props = {
  items?: InvoiceItemDto[];
};

export const VatTable = ({ items = [] }: Props) => {
  const sumByVat = (vat: number, fn: (item: InvoiceItemDto) => number) =>
    items
      .filter((ii) => Number(ii.vat) === vat)
      .reduce((sum, item) => sum + fn(item), 0);

  const sumAll = (fn: (item: InvoiceItemDto) => number) =>
    items.reduce((sum, item) => sum + fn(item), 0);

  const amount = (value: number) =>
    value === 0 ? <><b>&#8364;</b>-</> : (
      <>
        <b>&#8364;</b>
        {value.toFixed(2)}
      </>
    );

  const rows = [
    {
      label: 'Basis',
      calc: (i: InvoiceItemDto) => i.priceBefore,
    },
    {
      label: 'BTW',
      calc: (i: InvoiceItemDto) => i.priceTotal - i.priceBefore,
    },
    {
      label: 'TOTAAL',
      calc: (i: InvoiceItemDto) => i.priceTotal,
    },
  ];

  const vats = [0, 6, 21];

  return (
    <Box className="invoiceFooter">
      <Box className="vatTable">
        <Box className="row">
          <Typography className="block" />
          {vats.map((v) => (
            <Typography key={v} className="block head" variant="h5">
              {v}% BTW
            </Typography>
          ))}
          <Typography className="block totals head" variant="h5">
            TOTAAL
          </Typography>
        </Box>

        {rows.map((row) => (
          <Box className="row" key={row.label}>
            <Typography className="block title" variant="h5">
              {row.label}
            </Typography>

            {vats.map((v) => (
              <Typography key={v} className="block data" variant="h5">
                {amount(sumByVat(v, row.calc))}
              </Typography>
            ))}

            <Typography className="block totals" variant="h5">
              {amount(sumAll(row.calc))}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};